module.exports = __webpack_public_path__ + "newWebTMS/img/QMOL_Logo.7e3d5f4a.png";